import { CONFIGURE, NOTIFY, CLOSE } from "../../constants/Notifications";

const initialState = {
    configured: false,
    open: false,
    severity: "success",
    message: "",
};

function configure(state, { notification }) {
    return { ...state, ...notification, configured: true };
}

function notify(state, { severity, message }) {
    return { ...state, open: true, severity, message };
}

function close(state) {
    return { ...state, open: false, message: "" };
}

export default function loginReducer(state = initialState, { type, payload }) {
    switch (type) {
        case NOTIFY:
            return notify(state, payload);
        case CONFIGURE:
            return configure(state, payload);
        case CLOSE:
            return close(state);
        default:
            return state;
    }
}
